import { useInfiniteQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { ConfigurationChangelogListQuery } from '@rossum/api-client/configurationChangelog';
import { api } from '../../../lib/apiClient';
import { resolveNextPageParam } from '../../../lib/resolveNextPageParam';

export const QUERY_KEY_CONFIGURATION_CHANGELOG = 'configuration-changelog';

export const useConfigurationChangelog = (
  query: ConfigurationChangelogListQuery = {}
) =>
  useInfiniteQuery({
    queryKey: [QUERY_KEY_CONFIGURATION_CHANGELOG, query] as const,
    queryFn: ({ pageParam = 1 }) =>
      api.request(
        endpoints.configurationChangelog.list({
          ...query,
          page: pageParam,
        })
      ),
    getNextPageParam: resolveNextPageParam,
    cacheTime: 0,
  });
